import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ChatPage from './pages/ChatPage';
import RagPage from './pages/RagPage';
import TherapiePage from './pages/TherapiePage';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <h1>Therapie Chat</h1>
          <nav className="App-nav">
            <a href="/chat">Chat</a>
            <a href="/rag">Documents</a>
            <a href="/therapie">Historique</a>
          </nav>
        </header>
        <main className="App-main">
          <Routes>
            <Route path="/" element={<Navigate to="/chat" replace />} />
            <Route path="/chat" element={<ChatPage />} />
            <Route
              path="/rag"
              element={
                <ProtectedRoute>
                  <RagPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/therapie"
              element={
                <ProtectedRoute>
                  <TherapiePage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
